import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import ThemeProvider from '@synergycms_core/components/providers/themeProvider';
import ContentProvider from '@synergycms_core/components/providers/translateProvider';
import PopoverProvider from '@synergycms_core/components/providers/popoverProvider';
import SlideProvider from '@synergycms_core/components/providers/slideProvider';
import App from './containers/app/App.jsx';
import store from '@synergycms_core/configureStore.js';




window.availVersion = process.env.APP_VERSION;
console.log(process.env.APP_VERSION);
const engineData =  (window.frontLoader && window.frontLoader['cms-avail']?.config) || window.engine_sygy_data || {};

ReactDOM.render(
  <Provider store={store}>
    <ContentProvider value={{
      lang: (window.frontLoader && window.frontLoader.lang_info?.code ) || window.lang_info.code,
      theme: engineData.theme || window.synergyCmsAvailTheme,
      i18n: (window.frontLoader && window.frontLoader['cms-avail']?.i18n) || window.i18n,
      links: Object.assign(window.cmsLinks || {}, engineData.links)
    }}>
      <ThemeProvider value={{
        appId: "avail",
        theme: engineData.theme || window.synergyCmsAvailTheme,
        themeValues: engineData.theme_values || window.theme_values
      }}>
        <PopoverProvider>
          <SlideProvider>
            <App />
          </SlideProvider>
        </PopoverProvider>
      </ThemeProvider>
    </ContentProvider>
  </Provider>,
  document.getElementById('root')
);
